import * as React from 'react';
import { Row, Col } from 'antd';
import { RightAlignRow, LeftAlignRow } from 'components/Styled/Layout.Styled';

export interface Props {
  children?: React.ReactNode;
}

export interface State {}

export default class PrivacyPolicyView extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <LeftAlignRow>
        <Col>
          <p>
            Kingston Wharves Limited has a firm commitment to preserve our customers privacy.
            Kingston Wharves Limited does not store the financial information required by the
            payment service providers, or credit card companies. We only store the first four (4)
            and last four (4) digits of your credit card number for verification.
          </p>
          <p>
            All financial information is transmitted in an encrypted form. Please note that, while
            all attempts are made to secure information transmitted over this application, there is
            a possibility that information being transferred could be observed by a third party
            while in transit.
          </p>
        </Col>
      </LeftAlignRow>
    );
  }
}
